import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faPen } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { cx, css } from '@emotion/css';

const pageBg = css`
  background-color: #fdfbf7;
  background-image:
    radial-gradient(at 100% 0%, rgba(241, 102, 2, 0.04) 0px, transparent 50%),
    radial-gradient(at 0% 100%, rgba(244, 203, 14, 0.02) 0px, transparent 50%);
  min-height: 100vh;
  padding-bottom: 100px;
`;

const headerStyles = css`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(241, 102, 2, 0.08);
  margin-top: 2rem;

  .back-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    background: rgba(255,255,255,0.85);
    border: 1.5px solid rgba(241,102,2,0.18);
    border-radius: 12px;
    cursor: pointer;
    color: #f16602;
    font-size: 1.3rem;
    font-weight: 700;
    transition: all 0.2s ease;
    backdrop-filter: blur(8px);
    flex-shrink: 0;

    &:hover {
      background: #f16602;
      color: #ffffff;
      border-color: #f16602;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(241,102,2,0.25);
    }
  }

  .top-label {
    font-size: 0.7rem;
    font-weight: 700;
    color: #f16602;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    margin-bottom: 0.3rem;
  }

  h1 {
    font-size: 2.2rem;
    font-weight: 900;
    margin: 0;
    line-height: 1.1;
    color: #382110;

    .orange-part {
      color: #f16602;
      margin-right: 0.35em;
    }
  }
`;

const formCard = css`
  background: #ffffff;
  border: 1.5px solid rgba(241, 102, 2, 0.15);
  border-radius: 28px;
  padding: 2.5rem;
  box-shadow: 0 10px 40px rgba(241, 102, 2, 0.06);
`;

const iconBox = css`
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: linear-gradient(135deg, #fff3e6 0%, #ffe0c0 100%);
  border: 1.5px solid rgba(241,102,2,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.8rem;
  color: #f16602;
  font-size: 1.6rem;
`;

const labelStyle = css`
  display: block;
  font-size: 0.78rem;
  font-weight: 700;
  color: #382110;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 0.5rem;
`;

const inputStyle = css`
  width: 100%;
  height: 50px;
  border: 1.5px solid rgba(241, 102, 2, 0.18);
  border-radius: 14px;
  color: #382110;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0 18px;
  background: #fffcf9;
  box-sizing: border-box;
  outline: none;
  transition: all 0.2s ease;

  &:focus {
    border-color: #f16602;
    box-shadow: 0 0 0 3px rgba(241, 102, 2, 0.08);
    background: #ffffff;
  }

  &::placeholder {
    color: #c4a882;
    font-weight: 500;
  }
`;

const inputRow = css`
  display: flex;
  align-items: center;
  gap: 0.6rem;

  input {
    flex: 1;
    height: 50px;
    border: 1.5px solid rgba(241, 102, 2, 0.18);
    border-radius: 14px;
    color: #382110;
    font-weight: 600;
    font-size: 0.95rem;
    padding: 0 18px;
    background: #fffcf9;
    box-sizing: border-box;
    outline: none;
    transition: all 0.2s ease;

    &:focus {
      border-color: #f16602;
      box-shadow: 0 0 0 3px rgba(241, 102, 2, 0.08);
      background: #ffffff;
    }

    &::placeholder {
      color: #c4a882;
      font-weight: 500;
    }
  }

  .add-student-btn {
    height: 50px;
    width: 50px;
    flex-shrink: 0;
    background: #f16602;
    border: 0;
    border-radius: 14px;
    color: #ffffff;
    font-size: 1.1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(241, 102, 2, 0.25);

    &:hover {
      background: #d45500;
      transform: translateY(-2px);
      box-shadow: 0 6px 18px rgba(241, 102, 2, 0.35);
    }
  }
`;

const chipList = css`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const chipStyle = css`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: linear-gradient(135deg, #fff3e6 0%, #ffe8d0 100%);
  border: 1px solid rgba(241, 102, 2, 0.22);
  padding: 5px 12px 5px 8px;
  border-radius: 9999px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #382110;
  cursor: pointer;
  transition: all 0.2s ease;

  .chip-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: rgba(241,102,2,0.12);
    border-radius: 50%;
    color: #f16602;
    font-size: 0.6rem;
    flex-shrink: 0;
    transition: all 0.2s ease;
  }

  &:hover {
    background: linear-gradient(135deg, #ffe8d0 0%, #ffd4a8 100%);
    border-color: rgba(241, 102, 2, 0.45);

    .chip-close {
      background: #f16602;
      color: #ffffff;
    }
  }
`;

const fieldGroup = css`
  margin-bottom: 1.6rem;
`;

const errorText = css`
  background: rgba(255,77,77,0.07);
  border: 1px solid rgba(255,77,77,0.2);
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #cc2200;
  margin-bottom: 1.2rem;
`;

const btnRow = css`
  display: flex;
  gap: 0.8rem;
  margin-top: 2rem;
  flex-wrap: wrap;

  .btn-primary {
    flex: 1;
    height: 50px;
    background: #f16602;
    border: 0;
    border-radius: 14px;
    color: #ffffff;
    font-size: 0.85rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(241, 102, 2, 0.25);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(241, 102, 2, 0.35);
    }
  }

  .btn-ghost {
    flex: 1;
    height: 50px;
    background: transparent;
    border: 1.5px solid rgba(241, 102, 2, 0.25);
    border-radius: 14px;
    color: #f16602;
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(241, 102, 2, 0.06);
      border-color: #f16602;
      transform: translateY(-2px);
    }
  }
`;

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '50px',
    borderRadius: '14px',
    border: state.isFocused ? '1.5px solid #f16602' : '1.5px solid rgba(241,102,2,0.18)',
    background: '#fffcf9',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(241,102,2,0.08)' : 'none',
    fontWeight: 600,
    fontSize: '0.95rem',
    color: '#382110',
    '&:hover': { borderColor: '#f16602' },
  }),
  option: (base, state) => ({
    ...base,
    background: state.isSelected ? '#f16602' : state.isFocused ? '#fff3e6' : '#ffffff',
    color: state.isSelected ? '#ffffff' : '#382110',
    fontWeight: 600,
    cursor: 'pointer',
  }),
  singleValue: (base) => ({ ...base, color: '#382110', fontWeight: 600 }),
  placeholder: (base) => ({ ...base, color: '#c4a882', fontWeight: 500 }),
  menu: (base) => ({ ...base, borderRadius: '14px', overflow: 'hidden', border: '1.5px solid rgba(241,102,2,0.12)' }),
};

var Studentmap = {};

function EditBatch(props) {
  const categorytypes = ['Mathematics', 'General Knowledge', 'Chess', 'SpellBowl'];
  const history = useHistory();
  const [jwt, set_jwt] = useState('');
  const [email, set_Email] = useState('');
  const [username, set_username] = useState('');
  let data1 = useLocation();

  const [items, setItems] = useState([]);
  const [category, setCategory] = useState('');
  const [batchname, setBatchname] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [checks, setChecks] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    getToken();
    setBatchname(data1.state['name']);
    setCategory(data1.state['category']);
    setItems(data1.state['students']);
    Studentmap = {};
    for (let i = 0; i < data1.state['students'].length; i++) {
      Studentmap[data1.state['students'][i]] = 'add';
    }
    document.title = 'Edit Batch | QuizWizard';
  }, []);

  const getToken = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      Auth.currentSession().then((res) => {
        set_jwt(res.getAccessToken().getJwtToken());
        set_Email(user.attributes['email']);
        set_username(user.username.includes('Google_') ? user.attributes['email'] : user.username);
      });
    } catch (error) {
      Auth.signOut();
    }
  };

  const getuserDetails = async (uname) => {
    setIsAdding(true);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: uname }),
    };
    const response = await fetch('https://api.quizwizard.net/quiz/getuser', requestOptions);
    const data = await response.json();
    if (data !== 'No User') {
      setItems([...items, inputValue]);
      Studentmap[inputValue] = 'add';
      setInputValue('');
      setChecks('');
    } else {
      setChecks('Username not found. Please verify and try again.');
      setInputValue('');
    }
    setIsAdding(false);
  };

  const createBatch = async (cat, id, members, name, user, useremail, token) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: token },
      body: JSON.stringify({ category: cat, classowner: user, id, name, email: useremail, sendEmail: true, members }),
    };
    await fetch('https://api.quizwizard.net/quiz/createbatch', requestOptions);
  };

  const updateStudents = async (id, members, token) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: token },
      body: JSON.stringify({ id, members: Studentmap }),
    };
    await fetch('https://api.quizwizard.net/quiz/updatestudentsbatch', requestOptions);
    history.goBack();
  };

  const savestudents = async () => {
    if (items.length > 0) {
      setChecks('');
      setIsSaving(true);
      await createBatch(category, data1.state['id'], items, batchname, username, email, jwt);
      await updateStudents(data1.state['id'], items, jwt);
      setIsSaving(false);
    } else {
      setChecks('Please add at least one student before saving.');
    }
  };

  const handleAddButtonClick = () => {
    if (inputValue.trim().length) getuserDetails(inputValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleAddButtonClick();
  };

  const deleteStudent = (index) => {
    Studentmap[items[index]] = 'remove';
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  return (
    <div className={cx(pageBg)}>
      <div className="container" style={{ maxWidth: '760px', paddingTop: '1rem' }}>
        {/* Page Header */}
        <div className={cx(headerStyles)}>
          <button className="back-btn" onClick={() => history.goBack()}>&#8592;</button>
          <div>
            <div className="top-label">Batch Management</div>
            <h1><span className="orange-part">Edit</span>Batch</h1>
          </div>
        </div>

        {/* Form Card */}
        <div className={cx(formCard)}>
          <div className={cx(iconBox)}>
            <FontAwesomeIcon icon={faPen} />
          </div>

          {checks && <div className={cx(errorText)}>{checks}</div>}

          {/* Batch Name */}
          <div className={cx(fieldGroup)}>
            <label className={cx(labelStyle)}>Batch Name</label>
            <input
              className={cx(inputStyle)}
              value={batchname}
              onChange={(e) => setBatchname(e.target.value)}
              placeholder="Enter batch name..."
            />
          </div>

          {/* Category */}
          <div className={cx(fieldGroup)}>
            <label className={cx(labelStyle)}>Category</label>
            <Select
              styles={selectStyles}
              name="category"
              options={categorytypes.map((t) => ({ value: t, label: t }))}
              onChange={(e) => setCategory(e.value)}
              value={{ value: category, label: category }}
              placeholder="Select a category..."
            />
          </div>

          {/* Add Students */}
          <div className={cx(fieldGroup)}>
            <label className={cx(labelStyle)}>Students</label>
            <div className={cx(inputRow)}>
              <input
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Type a username and press +"
                disabled={isAdding}
              />
              <button className="add-student-btn" onClick={handleAddButtonClick} disabled={isAdding}>
                {isAdding ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 1s linear infinite' }}>
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                  </svg>
                ) : (
                  <FontAwesomeIcon icon={faPlus} />
                )}
              </button>
            </div>

            {/* Student Count Progress Bar */}
            {items.length > 0 && (
              <div style={{ marginTop: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                  <span style={{ fontSize: '0.75rem', fontWeight: '700', color: '#f16602', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                    Students Added
                  </span>
                  <span style={{ fontSize: '0.75rem', fontWeight: '800', color: '#382110' }}>
                    {items.length} / 30
                  </span>
                </div>
                <div style={{ background: '#f0ece8', borderRadius: '99px', height: '8px', overflow: 'hidden' }}>
                  <div style={{
                    height: '100%',
                    width: `${Math.min((items.length / 30) * 100, 100)}%`,
                    borderRadius: '99px',
                    background: items.length >= 30
                      ? 'linear-gradient(90deg, #ff4d4d, #cc0000)'
                      : 'linear-gradient(90deg, #ff9a45, #f16602)',
                    transition: 'width 0.5s cubic-bezier(0.25, 1, 0.5, 1)',
                    boxShadow: '0 2px 8px rgba(241, 102, 2, 0.35)',
                  }} />
                </div>
                {items.length >= 30 && (
                  <p style={{ fontSize: '0.78rem', color: '#cc0000', fontWeight: '600', marginTop: '6px', marginBottom: 0 }}>
                    ⚠️ Batch capacity reached (30 students max)
                  </p>
                )}
              </div>
            )}

            {items.length > 0 && (
              <div className={cx(chipList)}>
                {items.map((item, index) => (
                  <div key={index} className={cx(chipStyle)} onClick={() => deleteStudent(index)}>
                    <span className="chip-close"><FontAwesomeIcon icon={faTimes} /></span>
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

          {/* Save Progress Bar */}
          {isSaving && (
            <div style={{ margin: '1.5rem 0 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '0.78rem', fontWeight: '700', color: '#f16602', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                  Saving changes…
                </span>
                <span style={{ fontSize: '0.78rem', color: '#888', fontWeight: '600' }}>Please wait</span>
              </div>
              <div style={{ background: '#f0ece8', borderRadius: '99px', height: '8px', overflow: 'hidden' }}>
                <div style={{
                  height: '100%',
                  borderRadius: '99px',
                  background: 'linear-gradient(90deg, #ff9a45, #f16602)',
                  boxShadow: '0 2px 8px rgba(241,102,2,0.35)',
                  animation: 'saveProgress 2s ease-in-out infinite',
                }} />
              </div>
              <style>{`
                @keyframes saveProgress {
                  0%   { width: 5%; }
                  40%  { width: 60%; }
                  70%  { width: 80%; }
                  90%  { width: 92%; }
                  100% { width: 92%; }
                }
              `}</style>
            </div>
          )}

          {/* Buttons */}
          <div className={cx(btnRow)}>
            <button
              className="btn-primary"
              onClick={savestudents}
              disabled={isSaving}
              style={{ opacity: isSaving ? 0.6 : 1, cursor: isSaving ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
            >
              {isSaving ? (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 1s linear infinite' }}>
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                  </svg>
                  Saving…
                </>
              ) : 'Save Changes'}
            </button>
            <button className="btn-ghost" onClick={() => history.goBack()} disabled={isSaving} style={{ opacity: isSaving ? 0.5 : 1, cursor: isSaving ? 'not-allowed' : 'pointer' }}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditBatch;
